import {APIClient} from 'cx-api-client-lite';

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} TalkboxAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getGuestbooks
 * @property {ApiMethod} getComments
 * @property {ApiMethod} createComment
 * @property {ApiMethod} updateComment
 * @property {ApiMethod} deleteComment
 * @property {ApiMethod} getCommentReplies
 * @property {ApiMethod} updateCommentFlags
 * @property {ApiMethod} createCommentVote
 * @property {ApiMethod} deleteCommentVote
 */
/**
 * @type {TalkboxAPIClient | APIClient}
 */
const Talkbox = new APIClient({
  getGuestbooks: {
    path: '/talkbox/guestbooks',
    method: 'GET',
  },
  getComments: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments',
    method: 'GET',
  },
  getComment: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}',
    method: 'GET',
  },
  createComment: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments',
    method: 'POST',
  },
  deleteComment: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}',
    method: 'DELETE',
  },
  getCommentReplies: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}/replies',
    method: 'GET',
  },
  updateCommentFlags: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}/flags',
    method: 'PATCH',
  },
  createCommentVote: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}/votes',
    method: 'POST',
  },
  deleteCommentVote: {
    path: '/talkbox/guestbooks/{guestbook_key}/comments/{comment_id}/votes?vote_type={vote_type}',
    method: 'DELETE',
  },
});

export default Talkbox;
